export default __webpack_public_path__ + "static/media/noasklarge.d979ce33.png";